import { render } from "./AiAssistantFab.vue?vue&type=template&id=e6804d06&scoped=true"
import script from "./AiAssistantFab.vue?vue&type=script&lang=js"
export * from "./AiAssistantFab.vue?vue&type=script&lang=js"

import "./AiAssistantFab.vue?vue&type=style&index=0&id=e6804d06&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6804d06"]])

export default __exports__